"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countries = [
    {
        code: "AD",
        name: "Andorra",
    },
    {
        code: "AL",
        name: "Albania",
    },
    {
        code: "AO",
        name: "Angola",
    },
    {
        code: "AR",
        name: "Argentina",
    },
    {
        code: "AM",
        name: "Armenia",
    },
    {
        code: "AW",
        name: "Aruba",
    },
    {
        code: "AU",
        name: "Australia",
    },
    {
        code: "AZ",
        name: "Azerbaijan",
    },
    {
        code: "BS",
        name: "Bahamas",
    },
    {
        code: "BH",
        name: "Bahrain",
    },
    {
        code: "BB",
        name: "Barbados",
    },
    {
        code: "BY",
        name: "Belarus",
    },
    {
        code: "BZ",
        name: "Belize",
    },
    {
        code: "BJ",
        name: "Benin",
    },
    {
        code: "BF",
        name: "Burkina Faso",
    },
    {
        code: "GW",
        name: "Guinea-Bissau",
    },
    {
        code: "CI",
        name: "Ivory Coast",
    },
    {
        code: "ML",
        name: "Mali",
    },
    {
        code: "NE",
        name: "Niger",
    },
    {
        code: "SN",
        name: "Senegal",
    },
    {
        code: "TG",
        name: "Togo",
    },
    {
        code: "BM",
        name: "Bermuda",
    },
    {
        code: "BO",
        name: "Bolivar",
    },
    {
        code: "BO",
        name: "Bolivia",
    },
    {
        code: "BA",
        name: "Bosnia and Herzegovina",
    },
    {
        code: "BW",
        name: "Botswana",
    },
    {
        code: "BR",
        name: "Brazil",
    },
    {
        code: "BN",
        name: "Brunei",
    },
    {
        code: "BG",
        name: "Bulgaria",
    },
    {
        code: "KH",
        name: "Cambodia",
    },
    {
        code: "CM",
        name: "Cameroon",
    },
    {
        code: "CF",
        name: "Central African Republic",
    },
    {
        code: "TD",
        name: "Chad",
    },
    {
        code: "CG",
        name: "Republic of Congo",
    },
    {
        code: "GQ",
        name: "Equatorial Guinea",
    },
    {
        code: "GA",
        name: "Gabon",
    },
    {
        code: "CA",
        name: "Canada",
    },
    {
        code: "CV",
        name: "Cape Verde",
    },
    {
        code: "KY",
        name: "Cayman Islands",
    },
    {
        code: "CL",
        name: "Chile",
    },
    {
        code: "CL",
        name: "Chile",
    },
    {
        code: "CO",
        name: "Colombia",
    },
    {
        code: "KM",
        name: "Comoros",
    },
    {
        code: "CR",
        name: "Costa Rica",
    },
    {
        code: "HR",
        name: "Croatia",
    },
    {
        code: "CW",
        name: "Curacao and Sint Maarten",
    },
    {
        code: "CZ",
        name: "Czech Republic",
    },
    {
        code: "CD",
        name: "Democratic Republic of Congo",
    },
    {
        code: "DK",
        name: "Denmark",
    },
    {
        code: "DJ",
        name: "Djibouti",
    },
    {
        code: "DO",
        name: "Dominican Republic",
    },
    {
        code: "EC",
        name: "Eastern Caribbean",
    },
    {
        code: "EG",
        name: "Egypt",
    },
    {
        code: "EE",
        name: "Estonia",
    },
    {
        code: "ET",
        name: "Ethiopia",
    },
    {
        code: "EZ",
        name: "Euro area",
    },
    {
        code: "FK",
        name: "Falkland Islands",
    },
    {
        code: "FJ",
        name: "Fiji",
    },
    {
        code: "PF",
        name: "French Polynesia",
    },
    {
        code: "NC",
        name: "New Caledonia",
    },
    {
        code: "WF",
        name: "Wallis and Futuna",
    },
    {
        code: "GM",
        name: "Gambia",
    },
    {
        code: "GE",
        name: "Georgia",
    },
    {
        code: "GH",
        name: "Ghana",
    },
    {
        code: "GI",
        name: "Gibraltar",
    },
    {
        code: "GT",
        name: "Guatemala",
    },
    {
        code: "GN",
        name: "Guinea",
    },
    {
        code: "GY",
        name: "Guyana",
    },
    {
        code: "HT",
        name: "Haiti",
    },
    {
        code: "HN",
        name: "Honduras",
    },
    {
        code: "HK",
        name: "Hongkong",
    },
    {
        code: "HU",
        name: "Hungary",
    },
    {
        code: "IS",
        name: "Iceland",
    },
    {
        code: "IN",
        name: "India",
    },
    {
        code: "ID",
        name: "Indonesia",
    },
    {
        code: "IL",
        name: "Israel",
    },
    {
        code: "JM",
        name: "Jamaica",
    },
    {
        code: "JP",
        name: "Japan",
    },
    {
        code: "JO",
        name: "Jordan",
    },
    {
        code: "KZ",
        name: "Kazakhstan",
    },
    {
        code: "KE",
        name: "Kenya",
    },
    {
        code: "BT",
        name: "Kingdom of Bhutan",
    },
    {
        code: "KW",
        name: "Kuwait",
    },
    {
        code: "KG",
        name: "Kyrgyz Republic",
    },
    {
        code: "LA",
        name: "Laos",
    },
    {
        code: "LV",
        name: "Latvia",
    },
    {
        code: "LB",
        name: "Lebanon",
    },
    {
        code: "LS",
        name: "Lesotho",
    },
    {
        code: "LR",
        name: "Liberia",
    },
    {
        code: "LT",
        name: "Lithuania",
    },
    {
        code: "MO",
        name: "Macao",
    },
    {
        code: "MG",
        name: "Madagascar",
    },
    {
        code: "MW",
        name: "Malawi",
    },
    {
        code: "MY",
        name: "Malaysia",
    },
    {
        code: "MV",
        name: "Maldives",
    },
    {
        code: "MR",
        name: "Mauritania",
    },
    {
        code: "MU",
        name: "Mauritius",
    },
    {
        code: "MX",
        name: "Mexico",
    },
    {
        code: "MD",
        name: "Moldova",
    },
    {
        code: "MN",
        name: "Mongolia",
    },
    {
        code: "MZ",
        name: "Mozambique",
    },
    {
        code: "NA",
        name: "Namibia",
    },
    {
        code: "NZ",
        name: "New Zealand",
    },
    {
        code: "NI",
        name: "Nicaragua",
    },
    {
        code: "NG",
        name: "Nigeria",
    },
    {
        code: "MK",
        name: "North Macedonia",
    },
    {
        code: "NO",
        name: "Norway",
    },
    {
        code: "OM",
        name: "Oman",
    },
    {
        code: "PA",
        name: "Panama",
    },
    {
        code: "PG",
        name: "Papua New Guinea",
    },
    {
        code: "PY",
        name: "Paraguay",
    },
    {
        code: "PE",
        name: "Peru",
    },
    {
        code: "PL",
        name: "Poland",
    },
    {
        code: "TW",
        name: "Republic of China (Taiwan)",
    },
    {
        code: "RO",
        name: "Romania",
    },
    {
        code: "RU",
        name: "Russia",
    },
    {
        code: "RW",
        name: "Rwanda",
    },
    {
        code: "SH",
        name: "Saint Helena and Ascension",
    },
    {
        code: "SV",
        name: "Salvador",
    },
    {
        code: "WS",
        name: "Samoa",
    },
    {
        code: "ST",
        name: "Sao Tome and Principe",
    },
    {
        code: "SA",
        name: "Saudi Arabia",
    },
    {
        code: "RS",
        name: "Serbia",
    },
    {
        code: "SC",
        name: "Seychelles",
    },
    {
        code: "SL",
        name: "Sierra Leone",
    },
    {
        code: "SG",
        name: "Singapore",
    },
    {
        code: "SB",
        name: "Solomon Islands",
    },
    {
        code: "SO",
        name: "Somalia",
    },
    {
        code: "ZA",
        name: "South Africa",
    },
    {
        code: "KR",
        name: "South Korea",
    },
    {
        code: "LK",
        name: "Sri Lanka",
    },
    {
        code: "QA",
        name: "State of Qatar",
    },
    {
        code: "SR",
        name: "Suriname",
    },
    {
        code: "SZ",
        name: "Swaziland",
    },
    {
        code: "SE",
        name: "Sweden",
    },
    {
        code: "CH",
        name: "Switzerland and Liechtenstein",
    },
    {
        code: "TJ",
        name: "Tajikistan",
    },
    {
        code: "TZ",
        name: "Tanzania",
    },
    {
        code: "TH",
        name: "Thailand",
    },
    {
        code: "PH",
        name: "the Philippines",
    },
    {
        code: "TO",
        name: "Tonga",
    },
    {
        code: "TT",
        name: "Trinidad and Tobago",
    },
    {
        code: "TN",
        name: "Tunisia",
    },
    {
        code: "TR",
        name: "Turkey",
    },
    {
        code: "TM",
        name: "Turkmenistan",
    },
    {
        code: "US",
        name: "United States",
    },
    {
        code: "UG",
        name: "Uganda",
    },
    {
        code: "UA",
        name: "Ukraine",
    },
    {
        code: "AE",
        name: "United Arab Emirates",
    },
    {
        code: "GB",
        name: "United Kingdom",
    },
    {
        code: "JE",
        name: "Jersey",
    },
    {
        code: "GG",
        name: "Guernsey",
    },
    {
        code: "IM",
        name: "Isle of Man",
    },
    {
        code: "GS",
        name: "South Georgia and South Sandwich Islands",
    },
    {
        code: "BAT",
        name: "British Antarctic Territory",
    },
    {
        code: "TDC",
        name: "Tristan da Cunha",
    },
    {
        code: "UY",
        name: "Uruguay",
    },
    {
        code: "UZ",
        name: "Uzbekistan",
    },
    {
        code: "VU",
        name: "Vanuatu",
    },
    {
        code: "VN",
        name: "Vietnam",
    },
    {
        code: "ZM",
        name: "Zambia",
    },
];
exports.default = countries;
//# sourceMappingURL=countries.js.map